"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

var _validateRedirect = _interopRequireDefault(require("../validateRedirect"));

var _queryString = _interopRequireDefault(require("query-string"));

var _constants = require("../constants");

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _default = {
  redirect: function redirect() {
    var redirectToCustomerHomePage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (process.env.IS_BROWSER) {
      // Navigate to redirect page or home page
      var redirectLoc;

      var queryParams = _queryString.default.parse(document.location.search);

      var rCookie = _cookieUtils.default.getCookie('r');

      if (queryParams.redirect) {
        redirectLoc = decodeURI(queryParams.redirect);
      } else if (rCookie) {
        redirectLoc = rCookie.replace(/^"(.*)"$/, '$1');
      } else {
        redirectLoc = redirectToCustomerHomePage ? _urlCatalog.default.customer.customerHome() : '/';
      }

      _cookieUtils.default.deleteCookie('r');

      window.location.replace((0, _validateRedirect.default)(redirectLoc));
    }
  },
  redirectToLogin: function redirectToLogin() {
    if (_constants.isClient) {
      // Delete authToken cookie is for running on localhost only, since its an httponly cookie
      _cookieUtils.default.deleteCookie('authToken'); // todo isAuthenticated cookie can be removed after confirming if its not getting used.


      _cookieUtils.default.deleteCookie('isAuthenticated');

      var expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + 180000);

      _cookieUtils.default.setCookie('r', window.location.pathname, expireDate.toGMTString());

      window.location.replace("/login?redirect=".concat(encodeURIComponent(window.location.href)));
    }
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/utils/redirectionUtils.js
// module id = 3359
// module chunks = 25